import { render, staticRenderFns } from "./ServiceSubCategoriesForm.vue?vue&type=template&id=971f7bc0"
import script from "./ServiceSubCategoriesForm.vue?vue&type=script&lang=js"
export * from "./ServiceSubCategoriesForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceSubCategoriesForm.vue?vue&type=style&index=0&id=971f7bc0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports